module.exports = __webpack_public_path__ + "img/Shopp.fa642bcf.png";